import { gql } from 'graphql-request';

export const listCentralFillPharmaciesGql = gql`
  query listCentralFillPharmacies($filter: CentralFillPharmacyFilter) {
    listCentralFillPharmacies(filter: $filter) {
      compoundingPharmacyId
      name
      licensedStates
      isActive
    }
  }
`;

export const listCentralFillOrdersGql = gql`
  query listCentralFillOrders(
    $limit: Int
    $offset: Int
    $filter: CentralFillOrdersFilter
    $sortBy: CentralFillOrdersSortBy
  ) {
    centralFillOrders(limit: $limit, offset: $offset, filter: $filter, sortBy: $sortBy) {
      items {
        trackingId
        lineItemId
        orderId
        mpi
        patientName
        drugName
        strength
        ndc
        partnerName
        compoundingPharmacyId
        compoundingPharmacyName
        status
        errorDetail
        submittedAt
        lastUpdatedAt
      }
      totalCount
      limit
      offset
    }
  }
`;

export const resolveCentralFillReviewGql = gql`
  mutation resolveCentralFillReview($input: ResolveCentralFillReviewInput!) {
    resolveCentralFillReview(input: $input) {
      requestLineItemId
      status
      taggedForReview
      tags {
        tagName
        expiry
        createdAt
        isSystemTag
      }
    }
  }
`;

export const recallCentralFillOrdersGql = gql`
  mutation recallCentralFillOrders($input: RecallCentralFillOrdersInput!) {
    recallCentralFillOrders(input: $input) {
      results {
        lineItemId
        orderId
        trackingId
        success
        errorDetail
      }
      successCount
      failureCount
    }
  }
`;

export const forceReturnCentralFillOrdersGql = gql`
  mutation forceReturnCentralFillOrders($input: ForceReturnCentralFillOrdersInput!) {
    forceReturnCentralFillOrders(input: $input) {
      results {
        lineItemId
        orderId
        trackingId
        success
        errorDetail
      }
      successCount
      failureCount
    }
  }
`;

export const listCentralFillReasonsGql = gql`
  query listCentralFillReasons {
    listCentralFillReasons {
      code
      description
    }
  }
`;

export const repostCentralFillOrderGql = gql`
  mutation repostCentralFillOrder($input: RepostCentralFillOrderInput!) {
    repostCentralFillOrder(input: $input) {
      trackingId
      status
      reposted
      message
    }
  }
`;

export const updateCentralFillOrderStatusGql = gql`
  mutation updateCentralFillOrderStatus($input: UpdateCentralFillOrderStatusInput!) {
    updateCentralFillOrderStatus(input: $input) {
      trackingId
      orderId
      lineItemId
      previousStatus
      updatedStatus
    }
  }
`;

export const validateCentralFillEligibilityGql = gql`
  query validateCentralFillEligibility($lineItemIds: [ID!]!) {
    validateCentralFillEligibility(lineItemIds: $lineItemIds) {
      results {
        lineItemId
        orderId
        isEligible
        ineligibilityReasons
        partnerId
        partnerName
        drugName
        rxNumber
        productId
        state
      }
      totalRequested
      totalEligible
      totalIneligible
    }
  }
`;

export const sendOrdersToCentralFillGql = gql`
  mutation sendOrdersToCentralFill($lineItemIds: [ID!]!) {
    sendOrdersToCentralFill(lineItemIds: $lineItemIds) {
      results {
        lineItemId
        orderId
        sent
        reasons
        message
      }
      totalRequested
      totalSent
      totalSkipped
    }
  }
`;
